import {getAllDataDict} from "@/api/dict";

const state = {
  domain:[],// 所属领域
  demand_category:[],// 需求类型
  obtain_way:[],// 获取方式
  company_category: [],//意向合作单位
  maturity: [],//成熟度
  result_level: [],//成果水平
  region: [],//所在区域
  ip_right: [],//知识产权
  transfer_way: [],//转让方式
  institution: [],//所属机构
  device_category: [],//设备类别
  price_range: [],//价格范围
}
const getters = {
  getDictByKey: (state) => state.login,// 获取登录状态
  getUserInfo: (state) => state.userInfo,// 获取用户信息
}
const mutations = {

}
const actions = {
  async getAllDataDicAc(context){
    const res = await getAllDataDict()
    if(res.err_code===0){
      if(res.data){
        for(let key in res.data){
          context.state[key] = res.data[key] || []
        }
      }

    }
    return Promise.resolve(res)
  }

}
const modules = {}
export default {
  namespaced: true,
  state() {
    return state
  },
  getters,
  mutations,
  actions,
  modules
}

